import { agg_1, agg_2, agg_3 } from '../assets/images/agg/images.js';

const options_agg = [
	{
		title: 'Как создать агрегированные данные',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в подраздел «Агрегированные данные».',
					'3. Нажмите на кнопку «Сформировать агрегированные данные».',
				],
				image: agg_1.agg_1_1,
			},
			{
				text: [
					'4. Заполните все необходимые поля в появившемся окне формы. ',
					'5. Нажмите на кнопку «Сформировать».',
				],
				image: agg_1.agg_1_2,
			},
			{
				text: [
					'6. Агрегированные данные сформированы и находятся в подразделе «Агрегированные данные» в общем списке. Для просмотра данных необходимо выбрать из списка отчет и открыть его. Разделы для просмотра отображены в левом боковом меню. ',
				],
				image: agg_1.agg_1_3,
			},
		],
	},
	{
		title: 'Как обновить сформированные агрегированные данные',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в подраздел «Агрегированные данные».',
					'3. Выберите из списка отчет, который необходимо обновить.',
				],
				image: agg_2.agg_2_1,
			},
			{
				text: [
					'4. Нажмите на кнопку Рефреша.',
					'5. Агрегированные данные обновлены.',
				],
				image: agg_2.agg_2_2,
			},
		],
	},
	{
		title: 'Как скачать печатную форму сформированных агрегированных данных',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в подраздел «Агрегированные данные».',
					'3. Выберите из списка отчет, который необходимо скачать.',
				],
				image: agg_3.agg_3_1,
			},
			{
				text: [
					'4. Нажмите на кнопку «XLSX/PDF» в правом верхнем углу.',
					'5. Файл с агрегированными данными в формате XLSX и PDF был скачан на ваш локальный компьютер.',
				],
				image: agg_3.agg_3_2,
			},
		],
	},
];

export default options_agg;
